var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { global } from '../../utils';
import { GatewayNetworkType } from '../../types';
import EthernetIcon from '../../icons/Ethernet';
import DeviceMobileSignalState from '../DeviceMobileSignalState';
const GatewayConnectivityChip = (_a) => {
    var { networkInterface, signalQuality = 0, size = 16 } = _a, props = __rest(_a, ["networkInterface", "signalQuality", "size"]);
    switch (networkInterface) {
        case GatewayNetworkType.LAN:
        case GatewayNetworkType.ETHERNET:
            return _jsx(EthernetIcon, Object.assign({ size: size }, props), void 0);
        case GatewayNetworkType.LTE:
            return (_jsx(DeviceMobileSignalState, Object.assign({ signalQuality: signalQuality, size: size }, props), void 0));
        default:
            return _jsx(_Fragment, { children: global.NOT_AVAILABLE }, void 0);
    }
};
export default GatewayConnectivityChip;
